import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiSearch, BiFileFind } from "react-icons/bi";

import { getJrList, jrV2Selector } from "../job-request/jrV2Slice";
import { Colors } from "../../../assets/Colors";

// Halaman ini menampilkan JR V2 berstatus 99 (Menunggu Manifest).
const OperasionalShippingManifestPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jrV2 = useSelector(jrV2Selector);

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    dispatch(getJrList({ Status: "99" }));
  }, []); // eslint-disable-line

  useEffect(() => {
    const t = setTimeout(() => {
      dispatch(getJrList({ search: inputValue, Status: "99" }));
    }, 400);
    return () => clearTimeout(t);
  }, [inputValue]); // eslint-disable-line

  const list = jrV2.list ?? [];

  const goDetail = (row) =>
    navigate("/operasional-shipping-manifest-detail", { state: { JrID: row.JrID } });

  return (
    <div className="md:ml-64">
      <div style={{ background: Colors.primary }} className="pt-14 pb-20 px-8" />

      <div className="px-4 md:px-8 -mt-16">
        <div className="bg-white rounded-xl shadow-md overflow-hidden">

          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-lg font-bold text-gray-800">Shipping Manifest — Menunggu Manifest</h2>
          </div>

          {/* Search */}
          <div className="px-6 py-3 border-b bg-gray-50">
            <div className="relative max-w-sm">
              <BiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
              <input type="text" value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                placeholder="Cari JrID, no. QO, atau nama klien…"
                className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg outline-none" />
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            {jrV2.isLoading ? (
              <div className="flex items-center justify-center py-16 text-gray-400 text-sm">Memuat data…</div>
            ) : list.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                <span className="text-4xl mb-3">🚢</span>
                <p className="text-sm">Belum ada JR yang menunggu manifest</p>
              </div>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 text-left">
                    <th className="px-5 py-3 font-semibold text-gray-600">No. JR</th>
                    <th className="px-5 py-3 font-semibold text-gray-600">No. QO</th>
                    <th className="px-5 py-3 font-semibold text-gray-600">Nama Klien</th>
                    <th className="px-5 py-3 font-semibold text-gray-600">Tgl Kerja</th>
                    <th className="px-5 py-3 font-semibold text-gray-600">SPK No</th>
                    <th className="px-5 py-3 font-semibold text-gray-600 text-right">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {list.map(row => (
                    <tr key={row.JrID} className="hover:bg-blue-50">
                      <td className="px-5 py-3.5 font-mono text-xs text-gray-700">{row.JrID}</td>
                      <td className="px-5 py-3.5 font-mono text-xs text-gray-600">{row.QoNo}</td>
                      <td className="px-5 py-3.5 text-gray-700 max-w-[180px] truncate">{row.NamaKlien || row.KlienID}</td>
                      <td className="px-5 py-3.5 text-gray-700 whitespace-nowrap">{row.WorkDate}</td>
                      <td className="px-5 py-3.5 text-gray-600">{row.SPKNo || <span className="text-gray-400">—</span>}</td>
                      <td className="px-5 py-3.5 text-right">
                        <button onClick={() => goDetail(row)}
                          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-white text-xs font-medium"
                          style={{ background: Colors.primary }}>
                          <BiFileFind className="text-sm" /> Check Shipping Manifest
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {!jrV2.isLoading && list.length > 0 && (
            <div className="px-6 py-3 border-t bg-gray-50 text-xs text-gray-500">
              Menampilkan <strong>{list.length}</strong> JR menunggu manifest
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OperasionalShippingManifestPage;
